/* unplugin-vue-components disabled */import { render } from "./IndicatorValue.vue?vue&type=template&id=e5a43d20"
import script from "./IndicatorValue.vue?vue&type=script&lang=js"
export * from "./IndicatorValue.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__